import type { ObservationDeleteRelatedItemsProps } from "./observation-delete-related-items.type";

import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { useObservationDeleteRelatedItems } from "./observation-delete-related-items.hook";

import "./observation-delete-related-items.style.less";

const { Paragraph } = Typography;

export const ObservationDeleteRelatedItems = ({
  observation,
}: ObservationDeleteRelatedItemsProps) => {
  const { t } = useTranslation();
  const { itemsTypes, isLoading } =
    useObservationDeleteRelatedItems(observation);

  return (
    <>
      <Paragraph>{t("observation:delete.relatedItemsDesc")}</Paragraph>
      {isLoading ? (
        <Spin indicator={<LoadingOutlined spin />} />
      ) : (
        <ul className="observation-delete-related-items-list">
          {itemsTypes.map((itemType) => (
            <li key={itemType}>
              {t(`observation:delete.relatedItemsTypes.${itemType}`)}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
